var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "msp-table-view" },
    [
      _c(
        "div",
        { staticClass: "msp-table-view__subtitle" },
        [
          _c("pui-headline", { attrs: { type: "h6" } }, [
            _vm._v(" " + _vm._s(_vm.$t("tableView")) + " "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "msp-table-view__budget-deviation-chart-legend" },
        [
          _c("legend-item", {
            attrs: {
              "label-text": _vm.$t("tooLate"),
              color: _vm.budgetDeviationColors[0],
            },
          }),
          _c("legend-item", {
            attrs: {
              "label-text": _vm.$t("ok"),
              color: _vm.budgetDeviationColors[1],
            },
          }),
          _c("legend-item", {
            attrs: {
              "label-text": _vm.$t("tooEarly"),
              color: _vm.budgetDeviationColors[2],
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "msp-table-view__table-description" }, [
        _vm._v(" " + _vm._s(_vm.$t("calculatedMaintenance")) + " "),
      ]),
      _vm._l(_vm.tableRows, function (row, rIndex) {
        return [
          _c(
            "div",
            { key: "row-" + rIndex, staticClass: "msp-table-view__row" },
            [
              _c("div", { staticClass: "msp-table-view__row__header" }, [
                _vm._v(
                  " " + _vm._s(_vm.getLabelForCalculated(row.difference)) + " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "msp-table-view__row__items" },
                _vm._l(row.columns, function (column, cIndex) {
                  return _c(
                    "div",
                    {
                      key: "column-" + cIndex,
                      staticClass: "msp-table-view__row__items__cell",
                    },
                    [
                      column.numberMaintenances > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "msp-table-view__row__items__cell__cell-wrapper",
                              class: [
                                "msp-table-view__row__items__cell__cell-wrapper--severity-" +
                                  _vm.getSeverityForMaintenance(row.difference),
                              ],
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "msp-table-view__row__items__cell__cell-wrapper__budget",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(column.budgetInThousands + " ") +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "msp-table-view__row__items__cell__cell-wrapper__budget__currency",
                                    },
                                    [_vm._v("k" + _vm._s(_vm.currencySymbol))]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "msp-table-view__row__items__cell__cell-wrapper__no-items",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        column.numberMaintenances +
                                          " " +
                                          _vm.$t("activities")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      }),
      _c("div", { staticClass: "msp-table-view__row" }, [
        _c("div", { staticClass: "msp-table-view__row__header" }),
        _c(
          "div",
          { staticClass: "msp-table-view__row__items" },
          _vm._l(_vm.tableColumns, function (year, yIndex) {
            return _c(
              "div",
              {
                key: "year-" + yIndex,
                staticClass: "msp-table-view__row__items__cell",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "msp-table-view__row__items__cell__header msp-table-view__row__items__cell__year",
                  },
                  [_vm._v(" " + _vm._s(_vm.getYear(year)) + " ")]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        {
          staticClass:
            "msp-table-view__table-description msp-table-view__footer",
        },
        [_vm._v(" " + _vm._s(_vm.$t("plannedYearOfMaintenance")) + " ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }